import React from 'react';
import { pure } from 'recompose';


const Dagger = () => <sup>&dagger;</sup>;

export default pure(Dagger);
